/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of UUID
 */

export default abstract class UUID {

    /**
     *
     * @returns {string[]}
     */
    public static getByte2Hex(): string[] {
        const byteToHex: string[] = [];
        for (let i: number = 0; i < 256; ++i) {
            byteToHex[i] = (i + 0x100).toString(16).substr(1);
        }
        return byteToHex;
    }

    /**
     * bytes to uuid
     * @param {number[]} buf
     * @param {number} offset
     * @returns {string}
     */
    public static bytesToUuid(buf: number[], offset?: number): string {
        let i: number = offset || 0;
        const bth: string[] = UUID.getByte2Hex();
        // join used to fix memory issue caused by concatenation:
        // https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
        return ([bth[buf[i++]], bth[buf[i++]],
                 bth[buf[i++]], bth[buf[i++]], '-',
                 bth[buf[i++]], bth[buf[i++]], '-',
                 bth[buf[i++]], bth[buf[i++]], '-',
                 bth[buf[i++]], bth[buf[i++]], '-',
                 bth[buf[i++]], bth[buf[i++]],
                 bth[buf[i++]], bth[buf[i++]],
                 bth[buf[i++]], bth[buf[i++]]]).join('');
    }

    /**
     * 生成伪UUID
     * @returns {string}
     */
    public static get v4(): string {
        const rnds: number[] = new Array(16);
        let r: number = 0;
        for (let i: number = 0; i < 16; ++i) {
            if ((i & 0x03) === 0) {
                r = Math.random() * 0x100000000;
            }
            rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
        rnds[6] = (rnds[6] & 0x0f) | 0x40;
        rnds[8] = (rnds[8] & 0x3f) | 0x80;
        return UUID.bytesToUuid(rnds);
    }
}
